import { Routes } from '@angular/router'
import { accountGuard } from './account/account.guard';
import { environment } from '../environments/environment';

const routes: Routes = [
  {path: 'auth', loadChildren: () => import('./auth/auth.routes')},
  {path: 'account', loadChildren: () => import('./account/account.routes'), canActivate: [accountGuard]},
  {path: 'confirm', loadChildren: () => import('./confirm/confirm.routes')},
  {path: 'payment', loadChildren: () => import('./payment/payment.routes')},
  {path: '**', loadComponent: () => import('./app-redirect.component')},
]

if (!environment.production) {
  routes.unshift({path: 'banners', loadComponent: () => import('./banners/banners.component')})
}

export { routes }
